import { ContentChild, ContentChildren } from "@angular/core";

import { SpsTableBodyComponent } from "../table-body/sps-table-body.component";
import { SpsTableHeaderComponent } from "../table-header/sps-table-header.component";

export class SpsTableL0Base {
    static readonly props = {};

    @ContentChildren(SpsTableHeaderComponent, { descendants: true })
    headers: SpsTableHeaderComponent[];

    @ContentChild(SpsTableBodyComponent, { static: false })
    body: SpsTableBodyComponent;
}
